import { RecallDetailsPage } from '@/app/recalls/RecallDetailsPage';
import { RecallKindPage } from '@/app/recalls/RecallKindPage';
import { RecallTopicPage } from '@/app/recalls/RecallTopicPage';
import { RecallsPage } from '@/app/recalls/RecallsPage';
import { Navigate, Route, Routes } from 'react-router-dom';

export const RecallsRoutes = () => (
    <Routes>
        <Route index element={<Navigate replace to="catalog" />} />
        <Route path="catalog" element={<RecallsPage tab="catalog" />} />
        <Route path="no-matched-type" element={<RecallsPage tab="no-matched-type" />} />
        <Route path="no-matched-type/:productKind" element={<RecallKindPage />} />
        <Route path="topics" element={<RecallsPage tab="topics" />} />
        <Route path="topics/:topicId" element={<RecallTopicPage />} />
        <Route path="rejected" element={<RecallsPage tab="rejected" />} />
        <Route path="stalled" element={<RecallsPage tab="stalled" />} />
        {/* Static segments outrank this, so a recall can't shadow a tab. */}
        <Route path=":recallId/*" element={<RecallDetailsPage />} />
    </Routes>
);
